import React from 'react'
import { Text } from '@/components/atoms/Text'
import { ProcessItem } from '@/components/molecules/ProcessItem'
import './ProcessStep.css'

export interface ProcessSubItem {
  number: string
  title: string
  description: string
}

export interface ProcessStepProps {
  stepNumber: string
  title: string
  description: string
  subItems: ProcessSubItem[]
  className?: string
}

export const ProcessStep: React.FC<ProcessStepProps> = ({
  stepNumber,
  title,
  description,
  subItems,
  className = '',
}) => {
  return (
    <div className={`process-step ${className}`}>
      <div className="process-step-content">
        <div className="process-step-header">
          <Text size="small" color="gray" weight="medium" className="process-step-number">
            {stepNumber}
          </Text>
          <Text size="large" color="primary" weight="bold" className="process-step-title">
            {title}
          </Text>
          <Text size="large" color="gray" weight="medium" className="process-step-description">
            {description}
          </Text>
        </div>
      </div>
      <div className="process-step-card">
        {subItems.map((item, index) => (
          <ProcessItem
            key={index}
            number={item.number}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
  )
}
